/**
 * Used mainly by cmsLayouts, cmsModules and cmsBlocks to check if a specific option is inside the settings array and therefore active.
 * Can be used generaly to check if a value exists inside an array aswell.
 * @param {array} array - An array of values.
 * @param {(string|number)} value - A value that might exists inside the array.
 * @return {bool}
 */

export default (array = [], value) => array.indexOf(value) !== -1;
